<template>
  <div>
    <div class="air__utils__heading">
      <div class="row align-items-center">
        <div class="col-12 col-md-6">
          <h5 class="mb-0 font-weight-bold">
            Staff Attendance Update
            <span class="text-muted ml-2 font-size-14 font-weight-normal" v-if="date">
              [{{ moment(date).format('ddd DD, MMM YYYY') }}]
            </span>
          </h5>
        </div>
      </div>
    </div>
    <a-spin :spinning="loading" size="large">
      <single-update-element
        :date="date"
        :attendancedata="attendancedata"
        :summary="summary"
        @date-changed="handleDateChanged"
        @attendance-updated="fetchData"
      ></single-update-element>
    </a-spin>
  </div>
</template>

<script>
import moment from 'moment'
import singleUpdateElement from '@/components/StaffAttendance/Forms/singleupdate'

export default {
  components: { singleUpdateElement },
  data: function() {
    return {
      date: null,
      loading: false,
      attendancedata: [],
      summary: {
        total_staff: 0,
        total_present: 0,
        total_absent: 0,
        late_count: 0,
        early_left_count: 0,
        overtime_count: 0,
      },
    }
  },
  watch: {
    '$route.params.day': {
      handler: function(newDay) {
        this.initDate(newDay)
        this.fetchData()
      },
      immediate: true,
    },
  },
  methods: {
    moment,
    initDate(dayParam) {
      if (dayParam) {
        this.date = dayParam
      } else {
        this.date = moment().format('YYYY-MM-DD')
      }
    },
    fetchData() {
      if (!this.date) return
      this.loading = true
      this.$http.get(`/api/staff/attendance/report/daily?start_date=${this.date}&end_date=${this.date}`)
        .then((res) => {
          const resData = res.data && res.data.data
          if (resData) {
            this.summary = {
              total_staff: resData.total_staff || 0,
              total_present: resData.total_present || 0,
              total_absent: resData.total_absent || 0,
              late_count: resData.late_count || 0,
              early_left_count: resData.early_left_count || 0,
              overtime_count: resData.overtime_count || 0,
            }
            this.attendancedata = (resData.attendance || []).map(function(e) {
              return {
                date: e.date,
                staffname: `${e.first_name || ''} ${e.last_name || ''}`.trim(),
                holiday: e.is_holiday,
                staffid: e.staff_code,
                staffcode: e.staffId,
                status: e.status,
              }
            })
          } else {
            this.attendancedata = []
          }
        })
        .catch((err) => {
          console.error(err)
          this.$message.error('Failed to load attendance data')
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleDateChanged(newDate) {
      this.$router.push({ name: 'updatestaffattendancedaily', params: { day: newDate } })
    },
  },
}
</script>

<style scoped>
</style>
